"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateTemplates = exports.updateTemplate = void 0;
var Evaluation = __importStar(require("@cck/common/dist/data/Evaluation"));
var lodash_1 = __importDefault(require("lodash"));
var StorageManager_1 = require("../storage/StorageManager");
var ExcelParser_1 = require("./ExcelParser");
function updateTemplate(type, controlId, control) {
    return __awaiter(this, void 0, void 0, function () {
        var baseTemplateFileFullPath, blobData;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (type === Evaluation.Type.Operation) {
                        // 기본 운영평가 Template 의 Blob Data 를 가져와야 한다
                        baseTemplateFileFullPath = 'Template/(운영평가)(통제번호)(보고서)Template.xlsm';
                    }
                    else {
                        baseTemplateFileFullPath = 'Template/(설계평가)(통제번호)(보고서)Template.xlsx';
                    }
                    return [4 /*yield*/, (0, StorageManager_1.downloadBlobFromPath)(baseTemplateFileFullPath)];
                case 1:
                    blobData = _a.sent();
                    return [4 /*yield*/, (0, ExcelParser_1.editEvaluationTemplate)(type, controlId, control, blobData)];
                case 2: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
exports.updateTemplate = updateTemplate;
function updateTemplates(controlIds) {
    return __awaiter(this, void 0, void 0, function () {
        var _this = this;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: 
                /*
                해당 컨트롤 아이디들의 엑셀 보고서 템플릿을 현재 RCM 기준으로 맞춰준다
              
                @param: controlIdList: String[] - 대상이 되는 CONTROL id list
                */
                return [4 /*yield*/, Promise.all(lodash_1.default.map(controlIds, function (controlId) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, updateTemplate(Evaluation.Type.Operation, controlId, undefined)];
                                case 1:
                                    _a.sent();
                                    return [2 /*return*/];
                            }
                        });
                    }); }))];
                case 1:
                    /*
                    해당 컨트롤 아이디들의 엑셀 보고서 템플릿을 현재 RCM 기준으로 맞춰준다
                  
                    @param: controlIdList: String[] - 대상이 되는 CONTROL id list
                    */
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
exports.updateTemplates = updateTemplates;
//# sourceMappingURL=TemplateUpdater.js.map